import styled from 'styled-components';

export const StyledDayTimePreferencesField = styled.div`
   grid-column: span 2;
`;
StyledDayTimePreferencesField.displayName = 'StyledDayTimePreferencesField';
